// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_11828yPPRN","searchBox":"_1g_JFeIbUg","suggestionBox":"_3gYcyXhOs8","suggestionTitle":"_2ycjt7US08","suggestion":"_2Tz0DpLSUV"};